// Version : 1.0.0
// Author : AGALYA

/* eslint-disable import/no-anonymous-default-export */
import AddressExtraProofActionType from './address-extra-proof.types';

const INITIAL_STATE = {
	// update address proof response
	updateAddressExtraProofResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/** ***************** UPDATE ADDRESS EXTRA PROOF START *********************** */
		case AddressExtraProofActionType.UPDATE_ADDRESS_EXTRA_PROOF_SUCCESS:
			return { ...state, updateAddressExtraProofResponse: action.payload };

		case AddressExtraProofActionType.UPDATE_ADDRESS_EXTRA_PROOF_FAILURE:
			return { ...state, updateAddressExtraProofResponse: action.payload };

		case AddressExtraProofActionType.UPDATE_ADDRESS_EXTRA_PROOF_RESPONSE_CHANGED:
			return { ...state, updateAddressExtraProofResponse: null };
		/** ***************** UPDATE ADDRESS EXTRA PROOF END *********************** */

		default:
			return state;
	}
};
